import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Provlookup } from '../models/provlookup';
import { Client } from '../models/client';
import { PlaceDropDown } from '../models/placedropdown';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  public provList: Provlookup[] = [];
  public _busy: boolean = false;
  public _client: string = "";
  public showGp: boolean = false;
  public showDent: boolean = false;
  public showJoinDate: boolean = false;

  public totalPages: number = 0;
  public temList: Provlookup[] = [];
  public provinces: string[] = [];
  public cities: string[] = [];
  public suburbs: string[] = [];
  public showDropDown: boolean = false;
  public showSearch: boolean = false;
  public found: boolean = true;



  constructor(private _http: HttpClient, @Inject('BASE_URL') private _baseUrl: string) {
    this.GetClient();
  }

  SearchProviders(data: Provlookup) {
    this._busy = true;
    this.found = true;
    this._http.post(this._baseUrl + 'api/LookUp/SearchProviders', data
    ).subscribe((result: Provlookup[]) => {
      this.provList = [];
      if (result.length <= 0) {
        this.found = false;
      }
      result.forEach((el) => {
        this.provList.push(el);
      });
      let count = 0;
      let page = 1;
      let len = 0;

      this.provList.forEach((el) => {
        len++;
        count++;
        el.page = page;
        if (count == 10) {
          if (len == this.provList.length) {
            count = 0;
           // page++;
          } else {
            count = 0;
            page++;
          }

        }
      });
      this.totalPages = page;
      this.temList = this.provList.filter((a) => { if (a.page == 1) { return a; } })
    },
      (error) => {
        console.log(error);
      },
      () => {
        this._busy = false;
      });
  }

  SearchProvidersPerName(data: Provlookup) {
    this._busy = true;
    this.found = true;
    this._http.post(this._baseUrl + 'api/LookUp/SearchProvidersPerName', data
    ).subscribe((result: Provlookup[]) => {
      this.provList = [];
      if (result.length <= 0) {
        this.found = false;
      }
      result.forEach((el) => {
        this.provList.push(el);
      });
      let count = 0;
      let page = 1;
      let len = 0;

      this.provList.forEach((el) => {
        len++;
        count++;
        el.page = page;
        if (count == 10) {
          if (len == this.provList.length) {
            count = 0;
            // page++;
          } else {
            count = 0;
            page++;
          }

        }
      });
      this.totalPages = page;
      this.temList = this.provList.filter((a) => { if (a.page == 1) { return a; } })
    },
      (error) => {
        console.log(error);
      },
      () => {
        this._busy = false;
      });
  }

  GetClient() {
    this._busy = true;
    let token = localStorage.getItem('jwt');
    this._http.get(this._baseUrl + 'api/LookUp/GetClient'
    ).subscribe((result: Client) => {
      this._client = result.clientname;
      this.showGp = result.showGp;
      this.showDropDown = result.showDropDown;
      this.showSearch = result.showSearch;
      this.showDent = result.showDent;
      this.showJoinDate = result.showJoinDate;
    },
      (error) => {
        console.log(error);
      },
      () => {
        this._busy = false;
        this.GetProvinces();
      });
  }

  GetProvinces() {
    this._busy = true;
    let token = localStorage.getItem('jwt');
    this._http.get(this._baseUrl + 'api/LookUp/GetProvinces'
    ).subscribe((result: PlaceDropDown[]) => {
      this.provinces = [];
      result.forEach((el) => {
        this.provinces.push(el.city);
      })
    },
      (error) => {
        console.log(error);
      },
      () => {
        this._busy = false;
      });
  }


  GetCities(data: PlaceDropDown) {
    this._busy = true;
    let token = localStorage.getItem('jwt');
    this._http.post(this._baseUrl + 'api/LookUp/GetCities',data
    ).subscribe((result: PlaceDropDown[]) => {
      this.cities = [];
      result.forEach((el) => {
        this.cities.push(el.city);
      })
    },
      (error) => {
        console.log(error);
      },
      () => {
        this._busy = false;
        //this.GetSuburbs(data); Jaco 2024-02-19 this is stupid - don't get suburbs before a city is selected
      });
  }

  GetSuburbs(data: PlaceDropDown) {
    this._busy = true;
    let token = localStorage.getItem('jwt');
    this._http.post(this._baseUrl + 'api/LookUp/GetSuburbs', data
    ).subscribe((result: PlaceDropDown[]) => {
      this.suburbs = [];
      result.forEach((el) => {
        this.suburbs.push(el.suburb);
      })
    },
      (error) => {
        console.log(error);
      },
      () => {
        this._busy = false;
      });
  }


}
